<template>
  <InitioPageHeaderAndFooter>
    <div class="page section sorry">

      <div class="container">
        <div class="sad-computer">
          <div>
            <div></div>
          </div>
        </div>
        <h1>We're sorry, but initio can't cover this car today.</h1>

        <div class="columns is-centered">
          <div class="column is-6">
            <div class="chosen-vehicle-block" v-if="getAnswer('Vehicle.Plate','vehicle_plate')">
              <div class="plate">{{ getAnswer('Vehicle.Plate','vehicle_plate') }}</div>
              <div class="full_model">{{ getAnswer('Vehicle.Plate','vehicle_year') }} {{ getAnswer('Vehicle.Plate','vehicle_make') }} {{ getAnswer('Vehicle.Plate','vehicle_model') }}</div>
            </div>
            <template v-if="declineMessages">
              <h2>This is because of the following:</h2>
              <div class="box">
                <div class="content">
                  <ul class="error-list">
                    <li v-for="(message, key ) in declineMessages" :key="key">

                      <div v-if="typeof message === 'object'">
                        <h4 class="title is-6">{{ message.title }}</h4>
                        <p>{{ message.body }}</p>
                      </div>
                      <span v-else-if="typeof message !== 'object'">
                        <h4 class="title is-6">{{ message }}</h4>
                      </span>

                    </li>
                  </ul>
                </div>
              </div>
            </template>
          </div>
        </div>
        <div class="cant-insure-help">
          <h4 class="title is-6 mt-5">Have you filled in all the required information correctly?</h4>
          <div class="content">
            <p>Declaring/providing incorrect information to your insurance company can void your insurance at claim time.</p>
            <p>If you need more information <a href="/contact-us" target="_blank">contact us</a></p>
          </div>
        </div>
      </div>
      <div class="debug" v-if="envNotProd">
        <pre>All step data: {{ allAnswers }}</pre>
        <pre>Flattened Answers: {{ answers }}</pre>
        <pre>Answer Labels: {{ labels }}</pre>
      </div>
    </div>
  </InitioPageHeaderAndFooter>
</template>

<script>

import { mapGetters } from 'vuex'
import InitioPageHeaderAndFooter from '@/components/initio/InitioPageHeaderAndFooter.vue'

export default {
  props: {

  },
  components: {
    InitioPageHeaderAndFooter
  },
  computed: {
    ...mapGetters({
      currentSession: 'currentSession', 
      answers: 'flattenedAnswers',
      getAnswer: 'getAnswer',
      envNotProd: 'envNotProd'
        },
    ),
    allAnswers: {
      get () {
        return this.currentSession.answers;
      }
    },
    labels: {
      get () {
        return this.currentSession.labels;
      }
    },
    declineMessages() {
      return this.currentSession.backendData['Vehicle.Sorry'].decline
    },
  },
  mounted () {
    //console.log(this.declineMessages )
  },
  data () {
    let insurance_type = 'you vehicle';
    let based_on = 'main drivers claim history';
    let what_cant = 'Claim history';
    let no_insurance_link = '#main-driver-claim-history';

    return {
      schema: [],
      insurance_type: insurance_type,
      based_on: based_on,
      what_cant: what_cant,
      no_insurance_link: no_insurance_link,
    }
  },
}

</script>

<style scoped lang="scss">
  .sorry {
    flex-wrap:wrap;
  }
  .sad-computer {

    flex-basis: 100%;
    flex-shrink:0;
    flex-grow:0;
    margin:4rem 0;

    > div {
      display:block;
      border:3px solid rgba(130, 181, 65, 1);
      border-radius:50%;
      width:160px;
      height:160px;
      margin:0 auto;
      background-image:url("data:image/svg+xml;utf8,<svg width='92' height='84' viewBox='0 0 92 84' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M85.3375 0.312075H6.66284C3.0799 0.315669 0.179688 3.21946 0.179688 6.8024V63.3824C0.183282 66.9618 3.08339 69.862 6.66284 69.8656H33.2858L31.0218 80.0932H26.9536C25.9618 80.0932 25.1568 80.8982 25.1568 81.89C25.1568 82.8819 25.9618 83.6869 26.9536 83.6869H65.0471C66.039 83.6869 66.844 82.8819 66.844 81.89C66.844 80.8982 66.039 80.0932 65.0471 80.0932H60.979L58.715 69.8793H85.3379C88.9209 69.8758 91.8246 66.9648 91.8211 63.3819V6.80185C91.8211 3.21891 88.9209 0.315111 85.3379 0.311523L85.3375 0.312075ZM6.66284 3.90578H85.3375C86.1066 3.90578 86.8397 4.21125 87.3824 4.75391C87.9251 5.30016 88.227 6.03326 88.227 6.80238V54.1033H3.77373V6.80238C3.77373 6.03332 4.07561 5.30021 4.61826 4.75391C5.16092 4.21126 5.89403 3.90578 6.66315 3.90578H6.66284ZM57.2987 80.0928H34.7017L36.9657 69.879H55.0317L57.2987 80.0928ZM85.3403 66.2855H6.66192C5.89285 66.2855 5.15615 65.9764 4.61344 65.4337C4.07438 64.8875 3.76891 64.1508 3.77251 63.3817V57.6964H88.2257V63.3817C88.2257 64.1472 87.9239 64.8839 87.3812 65.4302C86.8386 65.9728 86.1019 66.2783 85.3363 66.2783L85.3403 66.2855Z' fill='%2382B541'/><path d='M35.9773 26.2552C35.9773 30.8767 29.0449 30.8767 29.0449 26.2552C29.0449 21.6337 35.9773 21.6337 35.9773 26.2552Z' fill='%2382B541'/><path d='M62.9558 26.2552C62.9558 30.8767 56.0234 30.8767 56.0234 26.2552C56.0234 21.6337 62.9558 21.6337 62.9558 26.2552Z' fill='%2382B541'/><path d='M53.7262 36.0376C53.6615 35.8363 52.0838 31.1357 45.9997 31.1357C39.9118 31.1357 38.3306 35.8364 38.2731 36.0376C38.212 36.2209 38.1797 36.4149 38.1797 36.609C38.1797 37.4931 38.8266 38.2441 39.7034 38.3807C40.5767 38.5137 41.4176 37.9926 41.6871 37.1481C41.8093 36.8211 42.7221 34.7403 45.9996 34.7403C49.2735 34.7403 50.1863 36.8246 50.3121 37.1481C50.578 37.9962 51.4225 38.5209 52.2995 38.3844C53.1764 38.2514 53.8232 37.4968 53.8232 36.6091C53.8232 36.415 53.7908 36.221 53.7298 36.0377L53.7262 36.0376Z' fill='%2382B541'/></svg>");
      background-position:center center;
      background-repeat:no-repeat;
    }
  }
  .box {
    margin-top:1.5rem;
  }
  h1 {
    flex-basis:100%;
    text-align:center;
    display:block;
    margin:0 auto;
    font-size:1.6rem;
    font-weight:700;
  }
  h2 {
    flex-basis:100%;
    text-align:center;
    display:block;
    margin:0 auto 1rem auto;
    color:rgba(113, 127, 134, 1);
    font-weight:400;
    font-size:1.2rem;
  }
  .cant-insure-help {
    flex-basis:100%;
    margin:0 auto;
    text-align:center;
    font-size:0.9rem;
  }
  li {
    padding-bottom:1rem;
    border-bottom:1px solid $light-grey;

    &:last-child {
      padding-bottom:0;
      border-bottom:none;
    }
  }

  .debug {
    width:100%;
    position:absolute;
    left:0;
    margin-top:3rem;
  }

  .chosen-vehicle-block {
    justify-content: center;
    margin:1rem 0;
    
    .plate {
      margin-right:1rem;
    }
  }


  ul.error-list {
    list-style:none;
    list-style-image: url("data:image/svg+xml;utf8,<svg width='24' height='24' viewBox='0 -8 20 28' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M10 0C4.48442 0 0 4.48442 0 10C0 15.5156 4.48442 20 10 20C15.5156 20 20 15.5156 20 10C20 4.48442 15.5156 0 10 0ZM13.8314 12.2105C14.2738 12.653 14.2738 13.3898 13.8314 13.8314C13.5995 14.0633 13.3264 14.1686 13.0312 14.1686C12.7368 14.1686 12.4416 14.0633 12.231 13.8314L9.99987 11.6209L7.78935 13.8314C7.55743 14.0633 7.28442 14.1686 6.98918 14.1686C6.69478 14.1686 6.39954 14.0633 6.18901 13.8314C5.74657 13.389 5.74657 12.6521 6.18901 12.2105L8.37891 10L6.16838 7.78947C5.72594 7.34703 5.72594 6.61019 6.16838 6.16859C6.61082 5.72615 7.34766 5.72615 7.78926 6.16859L9.99979 8.37912L12.2103 6.16859C12.6528 5.72615 13.3896 5.72615 13.8312 6.16859C14.2736 6.61103 14.2736 7.34787 13.8312 7.78947L11.6207 10L13.8314 12.2105Z' fill='%23B54141'/></svg>");
    li:first-child{
      margin-top: 0;
    }
    li {
      margin-top: 25px;
      p {
      //  margin-top:1rem;
       // background:#F00;
      }
    }
  }

</style>